/**
 * Norfolk Raider - Theme JavaScript
 */

(function() {
  'use strict';

  function closeMobileNav() {
    const m = document.querySelector('[data-mobile-nav]');
    const t = document.querySelector('[data-mobile-nav-toggle]');
    if (!m) return;
    m.removeAttribute('data-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('header--mobile-nav-open');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  /**
   * PDP gallery: sync main image + active thumb (mobile); optional desktop stack scroll.
   * @param {HTMLElement} productMedia - [data-product-media]
   * @param {string|number} imageId - Shopify media image id
   * @param {{ scrollDesktop?: boolean, scrollMobileThumb?: boolean }} [options]
   */
  function activateProductGalleryImage(productMedia, imageId, options) {
    if (!productMedia || imageId == null) return;
    const opts = options || {};
    const scrollDesktop = opts.scrollDesktop !== false;
    const scrollMobileThumb = opts.scrollMobileThumb !== false;
    const id = String(imageId);
    const thumb = productMedia.querySelector('[data-gallery-thumb][data-image-id="' + id + '"]');
    const mainImg = productMedia.querySelector('[data-product-main-image]');
    const desktopItem = productMedia.querySelector('.product-page__gallery-scroll--desktop [data-image-id="' + id + '"]');

    if (thumb && mainImg) {
      mainImg.src = thumb.dataset.mainSrc;
      if (thumb.dataset.mainSrcset) mainImg.srcset = thumb.dataset.mainSrcset;
      else mainImg.removeAttribute('srcset');
      mainImg.alt = thumb.dataset.mainAlt || '';
      mainImg.dataset.imageId = id;
      if (thumb.dataset.mainWidth) mainImg.setAttribute('width', thumb.dataset.mainWidth);
      if (thumb.dataset.mainHeight) mainImg.setAttribute('height', thumb.dataset.mainHeight);
      productMedia.querySelectorAll('[data-gallery-thumb]').forEach(function(t) {
        const isActive = t.getAttribute('data-image-id') === id;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (scrollMobileThumb && window.matchMedia('(max-width: 989px)').matches) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    } else if (mainImg && desktopItem) {
      const desktopImg = desktopItem.querySelector('img');
      if (desktopImg) {
        mainImg.src = desktopImg.src;
        if (desktopImg.srcset) mainImg.srcset = desktopImg.srcset;
        else mainImg.removeAttribute('srcset');
        mainImg.alt = desktopImg.alt || '';
        mainImg.dataset.imageId = id;
        const w = desktopImg.getAttribute('width');
        const h = desktopImg.getAttribute('height');
        if (w) mainImg.setAttribute('width', w);
        if (h) mainImg.setAttribute('height', h);
      }
    }

    if (scrollDesktop && desktopItem && window.matchMedia('(min-width: 990px)').matches) {
      desktopItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  document.querySelectorAll('[data-product-media]').forEach(function(productMedia) {
    productMedia.querySelectorAll('[data-gallery-thumb]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const id = btn.getAttribute('data-image-id');
        activateProductGalleryImage(productMedia, id, { scrollDesktop: false, scrollMobileThumb: false });
      });
    });
  });

  function buildCartPayload(form) {
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || 1, 10);
    const payload = { id: parseInt(id, 10), quantity };
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key.endsWith(']') && value) {
        const propKey = key.slice(11, -1);
        properties[propKey] = String(value);
      }
    }
    if (Object.keys(properties).length > 0) payload.properties = properties;
    return payload;
  }

  function getUnavailableStockMessage(button, variant) {
    const soldOutText = button?.dataset.soldOutText || 'Sold out';
    if (!button || !variant || variant.available) {
      return { text: soldOutText, isSpecial: false };
    }

    const specialVariantValue = (button.dataset.specialVariantValue || '').trim().toLowerCase();
    const specialUnavailableText = (button.dataset.specialUnavailableText || '').trim();
    if (!specialVariantValue || !specialUnavailableText) {
      return { text: soldOutText, isSpecial: false };
    }

    const options = [variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .map(function(value) { return String(value).trim().toLowerCase(); });
    if (options.includes(specialVariantValue)) {
      return { text: specialUnavailableText, isSpecial: true };
    }
    return { text: soldOutText, isSpecial: false };
  }

  function updateStockMessage(stockMessageEl, button, variant) {
    if (!stockMessageEl) return;
    if (!button || !variant) {
      stockMessageEl.hidden = true;
      stockMessageEl.textContent = '';
      return;
    }

    const setStockState = function(state) {
      stockMessageEl.dataset.stockState = state;
      stockMessageEl.classList.toggle('product-form__stock-message--in-stock', state === 'in-stock');
      stockMessageEl.classList.toggle('product-form__stock-message--unavailable', state === 'unavailable');
      stockMessageEl.classList.toggle('product-form__stock-message--special-unavailable', state === 'special-unavailable');
    };

    const inStockText = button.dataset.inStockText || 'In stock';
    stockMessageEl.hidden = false;
    if (variant.available) {
      setStockState('in-stock');
      stockMessageEl.textContent = inStockText;
      return;
    }

    const unavailableMessage = getUnavailableStockMessage(button, variant);
    setStockState(unavailableMessage.isSpecial ? 'special-unavailable' : 'unavailable');
    stockMessageEl.textContent = unavailableMessage.text;
  }

  // Multipack flavour picker – pack size from variant, flavours from product options
  document.querySelectorAll('[data-multipack-picker]').forEach(function(picker) {
    const variantSizesEl = picker.closest('form')?.querySelector('[data-multipack-variant-sizes]');
    let variantSizes = {};
    if (variantSizesEl) {
      try {
        variantSizes = JSON.parse(variantSizesEl.textContent || '{}');
      } catch (e) {}
    }

    function getPackSize() {
      return parseInt(picker.dataset.packSize || 12, 10);
    }

    function setPackSize(size) {
      const n = parseInt(size, 10) || 12;
      picker.dataset.packSize = String(n);
      picker.querySelectorAll('[data-multipack-pack-size]').forEach(function(el) {
        el.textContent = n;
      });
      picker.querySelectorAll('[data-multipack-input]').forEach(function(inp) {
        inp.max = n;
        const v = parseInt(inp.value || 0, 10);
        if (v > n) inp.value = n;
      });
      updateSummary();
    }

    const inputs = picker.querySelectorAll('[data-multipack-input]');
    const summaryInput = picker.querySelector('[data-multipack-summary]');
    const countEl = picker.querySelector('[data-multipack-count]');
    const errorEl = picker.querySelector('[data-multipack-error]');

    function updateSummary() {
      const packSize = getPackSize();
      let total = 0;
      const parts = [];
      inputs.forEach(function(inp) {
        const val = parseInt(inp.value || 0, 10);
        const max = parseInt(inp.max || packSize, 10);
        const capped = Math.min(Math.max(0, val), max);
        if (capped !== val) inp.value = capped;
        total += capped;
        if (capped > 0) parts.push(capped + ' ' + (inp.dataset.flavour || ''));
      });
      if (countEl) countEl.textContent = total;
      if (summaryInput) summaryInput.value = parts.join(', ');
      if (errorEl) errorEl.style.display = total === packSize ? 'none' : '';
      picker.classList.toggle('multipack-flavour-picker--complete', total === packSize && packSize > 0);
    }

    picker.querySelectorAll('[data-multipack-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const row = btn.closest('.multipack-flavour-picker__row');
        const input = row?.querySelector('[data-multipack-input]');
        if (input) {
          const v = Math.max(0, parseInt(input.value || 0, 10) - 1);
          input.value = v;
          updateSummary();
        }
      });
    });
    picker.querySelectorAll('[data-multipack-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const packSize = getPackSize();
        let total = 0;
        inputs.forEach(function(inp) { total += parseInt(inp.value || 0, 10); });
        const row = btn.closest('.multipack-flavour-picker__row');
        const input = row?.querySelector('[data-multipack-input]');
        if (input && total < packSize) {
          const current = parseInt(input.value || 0, 10);
          const maxForFlavour = parseInt(input.max || packSize, 10);
          const canAdd = Math.min(1, packSize - total, maxForFlavour - current);
          input.value = current + canAdd;
          updateSummary();
        }
      });
    });
    inputs.forEach(function(inp) {
      inp.addEventListener('input', function() {
        const packSize = getPackSize();
        const max = parseInt(inp.max || packSize, 10);
        let v = parseInt(inp.value || 0, 10);
        if (v > max) inp.value = max;
        v = parseInt(inp.value || 0, 10);
        let total = 0;
        inputs.forEach(function(i) { total += (i === inp ? 0 : parseInt(i.value || 0, 10)); });
        if (total + v > packSize) inp.value = Math.max(0, packSize - total);
        updateSummary();
      });
      inp.addEventListener('change', updateSummary);
    });
    updateSummary();

    document.addEventListener('theme:variantChange', function(e) {
      const variantId = e.detail?.variant?.id;
      if (variantId && variantSizes[variantId] != null) {
        setPackSize(variantSizes[variantId]);
        inputs.forEach(function(inp) {
          inp.value = 0;
        });
        updateSummary();
      }
    });
  });

  // Wishlist (localStorage)
  const WISHLIST_KEY = 'minitheme_wishlist';
  function getWishlist() {
    try {
      const raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function setWishlist(handles) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
      document.dispatchEvent(new CustomEvent('theme:wishlistUpdate', { detail: { handles } }));
    } catch (e) {}
  }
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const handle = this.dataset.productHandle;
      if (!handle) return;
      const list = getWishlist();
      const idx = list.indexOf(handle);
      if (idx >= 0) {
        list.splice(idx, 1);
        btn.classList.remove('product-card__wishlist-btn--active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      } else {
        list.push(handle);
        btn.classList.add('product-card__wishlist-btn--active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }
      setWishlist(list);
    });
  });
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
    const handle = btn.dataset.productHandle;
    if (handle && getWishlist().indexOf(handle) >= 0) {
      btn.classList.add('product-card__wishlist-btn--active');
      btn.setAttribute('aria-label', 'Remove from wishlist');
    }
  });

  // Age verification
  const AGE_VERIFY_KEY = 'norfolk_raider_age_verified';
  const ageModal = document.getElementById('age-verification');
  if (ageModal) {
    const confirmed = () => {
      try {
        localStorage.setItem(AGE_VERIFY_KEY, '1');
        sessionStorage.setItem(AGE_VERIFY_KEY, '1');
      } catch (e) {}
      ageModal.classList.remove('age-verification--visible');
      ageModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('age-verification-active');
    };
    const showModal = () => {
      ageModal.classList.add('age-verification--visible');
      ageModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('age-verification-active');
    };
    try {
      if (!localStorage.getItem(AGE_VERIFY_KEY) && !sessionStorage.getItem(AGE_VERIFY_KEY)) {
        showModal();
      }
    } catch (e) {
      showModal();
    }
    ageModal.querySelector('[data-age-verify="yes"]')?.addEventListener('click', confirmed);
    ageModal.querySelector('.age-verification__decline')?.addEventListener('click', function(e) {
      if (this.getAttribute('data-age-verify') === 'no') {
        e.preventDefault();
        window.location.href = this.getAttribute('href') || 'https://www.responsibility.org/';
      }
    });
  }

  // Cart toast (used after add-to-cart)
  let cartToastTimeout;
  const showCartToast = () => {
    const toast = document.getElementById('cart-toast');
    if (!toast) return;
    clearTimeout(cartToastTimeout);
    toast.setAttribute('aria-hidden', 'false');
    toast.classList.add('cart-toast--visible');
    cartToastTimeout = setTimeout(() => {
      toast.classList.remove('cart-toast--visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 2500);
  };

  // Cart drawer — refresh from /cart.js (Section Rendering API is unreliable for cart-drawer)
  function escapeHtmlAttr(s) {
    if (s == null || s === '') return '';
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeHtmlText(s) {
    if (s == null || s === '') return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function formatCartMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    var cur = currency || 'GBP';
    if (typeof cur === 'object' && cur && cur.iso_code) cur = cur.iso_code;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: String(cur)
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function updateHeaderCartCounts(cart) {
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    document.querySelectorAll('.header__cart-count').forEach(function(el) {
      el.textContent = String(n);
      el.hidden = n === 0;
    });
  }
  function buildCartDrawerHtml(cart) {
    var routes = window.themeRoutes || {};
    var cartBase = (routes.cartUrl || '/cart').replace(/\/$/, '');
    var changeBase = cartBase + '/change';
    var allProductsUrl = routes.allProductsUrl || '/collections/all';
    var currency = cart.currency || 'GBP';
    var itemCount = cart.item_count || 0;
    var totalPrice = cart.total_price || 0;

    if (itemCount === 0) {
      return (
        '<div class="cart-drawer" id="cart-drawer" data-cart-drawer aria-hidden="true">' +
        '<div class="cart-drawer__backdrop" data-cart-drawer-close aria-hidden="true"></div>' +
        '<div class="cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Cart">' +
        '<div class="cart-drawer__header"><h2 class="cart-drawer__title">Cart (0)</h2>' +
        '<button type="button" class="cart-drawer__close" data-cart-drawer-close aria-label="Close cart">×</button></div>' +
        '<div class="cart-drawer__body"><p class="cart-drawer__empty">Your cart is empty.</p>' +
        '<a href="' + escapeHtmlAttr(allProductsUrl) + '" class="button button--primary" data-cart-drawer-close>Continue shopping</a></div></div></div>'
      );
    }

    var itemsHtml = '';
    (cart.items || []).forEach(function(item, idx) {
      var line = item.line != null ? item.line : idx + 1;
      var removeHref = changeBase + '?line=' + encodeURIComponent(item.line != null ? item.line : line) + '&quantity=0';
      var imgUrl = item.image || (item.featured_image && (item.featured_image.url || item.featured_image.src)) || '';
      var imgTag = imgUrl
        ? '<img src="' + escapeHtmlAttr(imgUrl) + '" alt="" width="60" height="60" loading="lazy">'
        : '<div class="cart-drawer__item-placeholder"></div>';
      var productTitle = item.product_title || item.title || '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-drawer__item-variant">' + escapeHtmlText(item.variant_title) + '</span>' : '';
      var propsHtml = '';
      var props = item.properties;
      if (props && typeof props === 'object' && !Array.isArray(props)) {
        Object.keys(props).forEach(function(k) {
          if (!k || k.indexOf('_') === 0) return;
          var v = props[k];
          if (v != null && String(v) !== '') {
            propsHtml += '<span class="cart-drawer__item-property">' + escapeHtmlText(k) + ': ' + escapeHtmlText(String(v)) + '</span>';
          }
        });
      }
      var qty = typeof item.quantity === 'number' ? item.quantity : parseInt(item.quantity, 10) || 0;
      var productUrl = item.url || '#';
      itemsHtml +=
        '<div class="cart-drawer__item">' +
        '<a href="' + escapeHtmlAttr(productUrl) + '" class="cart-drawer__item-image">' + imgTag + '</a>' +
        '<div class="cart-drawer__item-details">' +
        '<a href="' + escapeHtmlAttr(productUrl) + '" class="cart-drawer__item-title">' + escapeHtmlText(productTitle) + '</a>' +
        variantTitle +
        propsHtml +
        '<span class="cart-drawer__item-qty">Qty ' + qty + '</span>' +
        '<span class="cart-drawer__item-price">' + escapeHtmlText(formatCartMoney(item.final_line_price != null ? item.final_line_price : item.line_price, currency)) + '</span>' +
        '</div>' +
        '<a href="' + escapeHtmlAttr(removeHref) + '" class="cart-drawer__item-remove" aria-label="Remove">×</a>' +
        '</div>';
    });

    return (
      '<div class="cart-drawer" id="cart-drawer" data-cart-drawer aria-hidden="true">' +
      '<div class="cart-drawer__backdrop" data-cart-drawer-close aria-hidden="true"></div>' +
      '<div class="cart-drawer__panel" role="dialog" aria-modal="true" aria-label="Cart">' +
      '<div class="cart-drawer__header"><h2 class="cart-drawer__title">Cart (' + itemCount + ')</h2>' +
      '<button type="button" class="cart-drawer__close" data-cart-drawer-close aria-label="Close cart">×</button></div>' +
      '<div class="cart-drawer__body">' +
      '<div class="cart-drawer__items">' +
      itemsHtml +
      '</div>' +
      '<div class="cart-drawer__footer">' +
      '<p class="cart-drawer__subtotal">Subtotal: ' + escapeHtmlText(formatCartMoney(totalPrice, currency)) + '</p>' +
      (routes.cartPoliciesHtml || '') +
      '<a href="' + escapeHtmlAttr(cartBase) + '" class="button button--primary">View cart</a>' +
      '</div></div></div></div>'
    );
  }

  function syncCartPageFromCart(cart) {
    var cartPage = document.querySelector('.cart-page');
    if (!cartPage) return;
    if (!cart.item_count) {
      window.location.reload();
      return;
    }
    var subtotalEl = cartPage.querySelector('.cart-page__subtotal');
    if (subtotalEl) {
      subtotalEl.textContent = 'Subtotal: ' + formatCartMoney(cart.total_price, cart.currency);
    }

    var keysInCart = {};
    (cart.items || []).forEach(function(item) {
      keysInCart[item.key] = item;
    });
    cartPage.querySelectorAll('.cart-item').forEach(function(row) {
      var key = row.getAttribute('data-line-key');
      if (!key || !keysInCart[key]) {
        row.remove();
        return;
      }
      var item = keysInCart[key];
      var qtyInput = row.querySelector('.cart-item__qty-input') || row.querySelector('input[data-line-index]');
      if (qtyInput) {
        qtyInput.value = item.quantity;
        if (item.line != null) qtyInput.setAttribute('data-line-index', String(item.line));
      }
      var priceEl = row.querySelector('.cart-item__price');
      if (priceEl) {
        priceEl.textContent = formatCartMoney(
          item.final_line_price != null ? item.final_line_price : item.line_price,
          cart.currency
        );
      }
    });
  }

  const cartDrawerRoot = document.getElementById('cart-drawer-root');

  function applyCartState(cart) {
    updateHeaderCartCounts(cart);
    if (cartDrawerRoot) cartDrawerRoot.innerHTML = buildCartDrawerHtml(cart);
    syncCartPageFromCart(cart);
  }
  let cartDrawerTrigger = null;
  const openCartDrawer = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    cartDrawerTrigger = document.activeElement;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.classList.add('cart-drawer--open');
    document.body.style.overflow = 'hidden';
    cartDrawer.querySelector('.cart-drawer__close')?.focus();
  };
  const closeCartDrawer = () => {
    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.classList.remove('cart-drawer--open');
    document.body.style.overflow = '';
    if (cartDrawerTrigger && typeof cartDrawerTrigger.focus === 'function') {
      cartDrawerTrigger.focus();
      cartDrawerTrigger = null;
    }
  };
  const refreshCartDrawer = () => {
    if (!cartDrawerRoot) return Promise.resolve();
    var cartJsUrl = (window.themeRoutes && window.themeRoutes.cartJsUrl) || '/cart.js';
    return fetch(cartJsUrl, { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('cart-js');
        return r.json();
      })
      .then(applyCartState)
      .catch(function() {});
  };

  function postCartLineChange(line, quantity) {
    var url = (window.themeRoutes && window.themeRoutes.cartChangeUrl) || '/cart/change.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(async function(r) {
      var data = await r.json();
      if (!r.ok) {
        var msg = (data && (data.description || data.message)) || 'Could not update cart';
        throw new Error(msg);
      }
      return data;
    });
  }
  document.querySelectorAll('[data-cart-drawer-trigger]').forEach(el => {
    el.addEventListener('click', function(e) {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      closeMobileNav();
      refreshCartDrawer().then(openCartDrawer);
    });
  });
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-close]')) closeCartDrawer();
  });
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapTabInContainer(e, container) {
    if (e.key !== 'Tab' || !container) return;
    const list = Array.from(container.querySelectorAll(focusableSelector)).filter(function(el) {
      return el.offsetParent !== null && !el.hasAttribute('disabled');
    });
    if (list.length === 0) return;
    const first = list[0];
    const last = list[list.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('keydown', function(e) {
    const drawer = document.getElementById('cart-drawer');
    const quickModal = document.getElementById('quick-add-modal');
    const mobileNavEl = document.querySelector('[data-mobile-nav]');
    if (e.key === 'Escape' && drawer?.classList.contains('cart-drawer--open')) closeCartDrawer();
    else if (e.key === 'Escape' && quickModal?.classList.contains('quick-add-modal--open')) closeQuickAdd();
    else if (e.key === 'Escape' && document.querySelector('[data-mobile-nav][data-open]')) closeMobileNav();
    else if (drawer?.classList.contains('cart-drawer--open')) trapTabInContainer(e, drawer);
    else if (quickModal?.classList.contains('quick-add-modal--open')) trapTabInContainer(e, quickModal);
    else if (mobileNavEl?.hasAttribute('data-open')) trapTabInContainer(e, mobileNavEl);
  });

  document.addEventListener('focusin', function(e) {
    if (!(e.target instanceof HTMLElement)) return;
    const t = e.target;
    const drawer = document.getElementById('cart-drawer');
    if (drawer && drawer.classList.contains('cart-drawer--open') && !drawer.contains(t)) {
      drawer.querySelector('.cart-drawer__close')?.focus();
      return;
    }
    const quickModal = document.getElementById('quick-add-modal');
    if (quickModal && quickModal.classList.contains('quick-add-modal--open') && !quickModal.contains(t)) {
      const closeBtn = quickModal.querySelector('.quick-add-modal__close');
      const inner = quickModal.querySelector('[data-quick-add-content]');
      const innerFocus = inner && inner.querySelector(focusableSelector);
      (innerFocus || closeBtn)?.focus();
      return;
    }
    const mobileNavEl = document.querySelector('[data-mobile-nav]');
    if (mobileNavEl && mobileNavEl.hasAttribute('data-open') && !mobileNavEl.contains(t)) {
      mobileNavEl.querySelector('[data-mobile-nav-close]')?.focus();
    }
  });

  // Inline expanding search with AJAX predictive search
  let closeSearch = function() {};
  const searchToggles = document.querySelectorAll('[data-search-toggle]');
  const searchInline = document.querySelector('[data-search-inline]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchClose = document.querySelector('[data-search-close]');

  if (searchToggles.length && searchInline && searchInput) {
    let searchDebounce;
    const routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const header = document.querySelector('.header');
    const setSearchExpanded = (expanded) => {
      searchToggles.forEach(function(t) {
        t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const openSearch = () => {
      closeMobileNav();
      searchInline.setAttribute('data-open', '');
      searchInline.setAttribute('aria-hidden', 'false');
      setSearchExpanded(true);
      header?.classList.add('header--search-open');
      searchInput.focus();
    };

    closeSearch = () => {
      searchInline.removeAttribute('data-open');
      searchInline.setAttribute('aria-hidden', 'true');
      setSearchExpanded(false);
      header?.classList.remove('header--search-open');
      searchResults.removeAttribute('data-has-results');
      searchResults.innerHTML = '';
    };

    const renderResults = (data) => {
      if (!data || !data.resources || !data.resources.results) {
        searchResults.removeAttribute('data-has-results');
        searchResults.innerHTML = '';
        return;
      }
      const r = data.resources.results;
      const products = r.products || [];
      const collections = r.collections || [];
      const pages = r.pages || [];
      const queries = r.queries || [];
      const items = [];

      queries.slice(0, 2).forEach(q => {
        if (q.url && q.text) items.push({ type: 'query', url: q.url, title: q.text.replace(/<[^>]+>/g, '') });
      });
      products.slice(0, 4).forEach(p => {
        items.push({ type: 'product', url: p.url, title: p.title, price: p.price, image: p.featured_image?.url || p.image });
      });
      collections.slice(0, 2).forEach(c => {
        items.push({ type: 'collection', url: c.url, title: c.title });
      });
      pages.slice(0, 2).forEach(p => {
        items.push({ type: 'page', url: p.url, title: p.title });
      });

      if (items.length === 0) {
        searchResults.removeAttribute('data-has-results');
        searchResults.innerHTML = '';
        return;
      }

      const html = items.map(item => {
        const typeLabel = item.type === 'product' ? 'Product' : item.type === 'collection' ? 'Collection' : item.type === 'page' ? 'Page' : '';
        const priceHtml = item.price != null ? `<span class="header__search-result-price">${formatMoney(item.price)}</span>` : '';
        const typeHtml = typeLabel ? `<span class="header__search-result-type">${escapeHtml(typeLabel)}</span>` : '';
        const imgHtml = item.image ? `<img src="${escapeHtml(item.image)}" alt="" class="header__search-result-img" width="40" height="40" loading="lazy">` : '';
        return `<a href="${escapeHtml(item.url)}" class="header__search-result-item">
          ${imgHtml}
          <div class="header__search-result-text">
            <span class="header__search-result-title">${escapeHtml(item.title)}</span>
            ${priceHtml}
            ${typeHtml}
          </div>
        </a>`;
      }).join('');

      searchResults.innerHTML = html;
      searchResults.setAttribute('data-has-results', '');
    };

    const escapeHtml = (s) => {
      if (!s) return '';
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    };

    const formatMoney = (val) => {
      if (val == null) return '';
      const amount = (typeof val === 'number' && val >= 100) ? val / 100 : val;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
      } catch (e) {
        return '£' + Number(amount).toFixed(2);
      }
    };

    searchInput.addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(searchDebounce);
      if (q.length < 2) {
        searchResults.removeAttribute('data-has-results');
        searchResults.innerHTML = '';
        return;
      }
      searchDebounce = setTimeout(() => {
        const url = routesRoot.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,query&resources[options][unavailable_products]=hide&resources[limit]=10';
        fetch(url)
          .then(res => res.json())
          .then(renderResults)
          .catch(() => {
            searchResults.removeAttribute('data-has-results');
            searchResults.innerHTML = '';
          });
      }, 200);
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });

    searchToggles.forEach(function(searchToggle) {
      searchToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        if (searchInline.hasAttribute('data-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    });

    searchClose?.addEventListener('click', closeSearch);

    document.addEventListener('click', function(e) {
      if (searchInline.hasAttribute('data-open') && !searchInline.contains(e.target) && !e.target.closest('[data-search-toggle]')) {
        closeSearch();
      }
    });
  }

  const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileNavToggle && mobileNav) {
    const openMobileNav = () => {
      closeSearch();
      mobileNav.setAttribute('data-open', '');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.classList.add('header--mobile-nav-open');
      mobileNavToggle.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function() {
        mobileNav.querySelector('[data-mobile-nav-close]')?.focus();
      });
    };

    mobileNavToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      if (mobileNav.hasAttribute('data-open')) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });

    document.querySelectorAll('[data-mobile-nav-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        closeMobileNav();
      });
    });

    mobileNav.querySelectorAll('.header__mobile-link, .header__mobile-sublink').forEach(function(link) {
      link.addEventListener('click', function() {
        closeMobileNav();
      });
    });
  }

  // Header scroll effect
  const header = document.querySelector('.header');
  if (header) {
    const handleScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  // Product variant picker
  const productForm = document.getElementById('product-form') || document.querySelector('form.product-form');
  if (productForm) {
    const variantPicker = productForm.querySelector('[data-variant-picker]');
    const variantIdInput = productForm.querySelector('[data-variant-id]');
    const variantJsonEl = productForm.querySelector('[data-variant-json]');

    if (variantPicker && variantIdInput && variantJsonEl) {
      let variants;
      try {
        variants = JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        variants = [];
      }

      const getOptionValues = () => {
        const values = {};
        variantPicker.querySelectorAll('[data-option-input]').forEach(input => {
          if (input.type === 'hidden' || input.checked) {
            const pos = input.getAttribute('data-option-position');
            if (pos) values[pos] = input.value;
          }
        });
        return values;
      };

      const findVariant = () => {
        const selected = getOptionValues();
        return variants.find(v => {
          const o1 = selected['1'] !== undefined ? selected['1'] : v.option1;
          const o2 = selected['2'] !== undefined ? selected['2'] : v.option2;
          const o3 = selected['3'] !== undefined ? selected['3'] : v.option3;
          return String(v.option1 || '') === String(o1 || '') &&
                 String(v.option2 || '') === String(o2 || '') &&
                 String(v.option3 || '') === String(o3 || '');
        });
      };

      const formatMoney = (cents) => {
        let currency = 'GBP';
        try {
          const currEl = productForm.querySelector('[data-currency]');
          if (currEl) {
            const parsed = JSON.parse(currEl.textContent);
            currency = typeof parsed === 'string' ? parsed : (parsed?.iso_code || parsed?.isoCode || 'GBP');
          }
        } catch (e) {}
        return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
          style: 'currency',
          currency: String(currency)
        }).format(cents / 100);
      };

      const updateVariant = (variant) => {
        if (!variant) return;
        variantIdInput.value = variant.id;

        const sticky = productForm.closest('.product-page__purchase-sticky');
        const priceWrap = sticky?.querySelector('[data-product-price-wrap]');
        const priceAmounts = priceWrap?.querySelector('[data-product-price-amounts]');
        const priceAltMsg = priceWrap?.querySelector('[data-price-alt-message]');
        const priceEl = sticky?.querySelector('[data-price]');
        const comparePriceEl = sticky?.querySelector('[data-compare-price]');
        const addBtn = productForm.querySelector('[data-add-to-cart]');
        const stockMessage = productForm.querySelector('[data-stock-message]');
        const productMedia = document.querySelector('[data-product-media]');

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          comparePriceEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
          comparePriceEl.style.display = variant.compare_at_price > variant.price ? '' : 'none';
        }

        const unavailableForPrice = getUnavailableStockMessage(addBtn, variant);
        const showSpecialPriceAlt = Boolean(!variant.available && unavailableForPrice.isSpecial);
        const specialPriceText = (addBtn?.dataset.specialUnavailableText || '').trim();
        if (priceAmounts) priceAmounts.style.display = showSpecialPriceAlt ? 'none' : '';
        if (priceAltMsg) {
          priceAltMsg.style.display = showSpecialPriceAlt ? '' : 'none';
          if (showSpecialPriceAlt) priceAltMsg.textContent = specialPriceText;
        }

        const mobileBar = document.querySelector('[data-product-mobile-bar]');
        const mbAmounts = mobileBar?.querySelector('[data-mobile-price-amounts]');
        const mbAlt = mobileBar?.querySelector('[data-mobile-price-alt-message]');
        const mbPrice = mobileBar?.querySelector('[data-product-price]');
        if (mbPrice) mbPrice.textContent = formatMoney(variant.price);
        if (mbAmounts) mbAmounts.style.display = showSpecialPriceAlt ? 'none' : '';
        if (mbAlt) {
          mbAlt.style.display = showSpecialPriceAlt ? '' : 'none';
          if (showSpecialPriceAlt) mbAlt.textContent = specialPriceText;
        }

        const mbBtn = mobileBar?.querySelector('[data-mobile-add-to-cart]');
        if (mbBtn) {
          mbBtn.disabled = !variant.available;
          mbBtn.classList.toggle('button--disabled', !variant.available);
          mbBtn.textContent = mbBtn.dataset.addText || addBtn?.dataset.addText || 'Add to cart';
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.classList.toggle('button--disabled', !variant.available);
          addBtn.textContent = addBtn.dataset.addText || 'Add to cart';
        }
        updateStockMessage(stockMessage, addBtn, variant);
        if (productMedia && variant.featured_image) {
          activateProductGalleryImage(productMedia, variant.featured_image.id);
        }
        variantPicker.querySelectorAll('.variant-picker__swatch--selected, .variant-picker__radio--selected').forEach(el => el.classList.remove('variant-picker__swatch--selected', 'variant-picker__radio--selected'));
        variantPicker.querySelectorAll('[data-option-input]').forEach(input => {
          if (input.type === 'hidden' || input.checked) {
            const label = input.closest('label');
            if (label) label.classList.add('variant-picker__swatch--selected', 'variant-picker__radio--selected');
          }
        });
      };

      const addBtn = productForm.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.dataset.addText = addBtn.textContent;
      const mobileBarInit = document.querySelector('[data-product-mobile-bar]');
      const mobileBarBtnInit = mobileBarInit?.querySelector('[data-mobile-add-to-cart]');
      if (mobileBarBtnInit) mobileBarBtnInit.dataset.addText = mobileBarBtnInit.textContent;

        const onVariantChange = function(e) {
        if (!e.target.matches('[data-option-input]')) return;
        const v = findVariant();
        updateVariant(v);
        if (v) {
          const addBtn = productForm.querySelector('[data-add-to-cart]');
          document.dispatchEvent(new CustomEvent('theme:variantChange', { detail: { variant: v, productId: addBtn?.dataset.productId, productHandle: addBtn?.dataset.productHandle } }));
        }
      };
      variantPicker.addEventListener('change', onVariantChange);
      variantPicker.addEventListener('input', onVariantChange);

      const mobileBar = document.querySelector('[data-product-mobile-bar]');
      const purchaseBlock = productForm.closest('.product-page__purchase') || productForm.closest('.product-page__purchase-sticky');
      if (mobileBar && purchaseBlock && window.matchMedia('(max-width: 989px)').matches) {
        const mobileBarBtn = mobileBar.querySelector('[data-mobile-add-to-cart]');
        mobileBarBtn?.addEventListener('click', () => {
          if (productForm && !mobileBarBtn.disabled) productForm.requestSubmit();
        });
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            mobileBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
          });
        }, { rootMargin: '-60px 0px 80px 0px', threshold: 0 });
        observer.observe(purchaseBlock);
      }
    }

    // Product form AJAX submit + toast
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const multipackPicker = productForm.querySelector('[data-multipack-picker]');
      if (multipackPicker) {
        const packSize = parseInt(multipackPicker.dataset.packSize || 12, 10);
        const total = parseInt(multipackPicker.querySelector('[data-multipack-count]')?.textContent || 0, 10);
        const errorEl = multipackPicker.querySelector('[data-multipack-error]');
        if (total !== packSize) {
          if (errorEl) {
            errorEl.style.display = '';
            errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
          return;
        }
        if (errorEl) errorEl.style.display = 'none';
      }
      const payload = buildCartPayload(productForm);
      const submitBtn = productForm.querySelector('[data-add-to-cart]') || productForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(async function(r) {
          const data = await r.json();
          if (!r.ok) throw new Error(data.description || data.message || 'add-failed');
          return data;
        })
        .then(function(lineItem) {
          return refreshCartDrawer().then(function() { return lineItem; });
        })
        .then(function(lineItem) {
          showCartToast();
          const btn = productForm.querySelector('[data-add-to-cart]');
          document.dispatchEvent(new CustomEvent('theme:addToCart', {
            detail: { lineItem, productId: btn?.dataset.productId, productHandle: btn?.dataset.productHandle, variantId: payload.id }
          }));
        })
        .catch(function() {})
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  // Featured product carousel
  document.querySelectorAll('[data-carousel-track]').forEach(track => {
    const section = track.closest('.product-carousel');
    if (!section) return;
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const slideWidth = 280;
    const gap = 32;
    const scrollAmount = slideWidth + gap;
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });

  // Quick add modal
  const quickAddModal = document.getElementById('quick-add-modal');
  const quickAddContent = document.querySelector('[data-quick-add-content]');
  const quickAddTriggers = () => document.querySelectorAll('[data-quick-add-trigger]');
  let quickAddTrigger = null;

  const openQuickAdd = (handle) => {
    if (!quickAddModal || !quickAddContent) return;
    quickAddTrigger = document.activeElement;
    document.dispatchEvent(new CustomEvent('theme:quickAddOpen', { detail: { productHandle: handle } }));
    quickAddContent.innerHTML = '<p class="quick-add-modal__loading">Loading…</p>';
    quickAddModal.setAttribute('aria-hidden', 'false');
    quickAddModal.classList.add('quick-add-modal--open');
    document.body.style.overflow = 'hidden';
    quickAddModal.querySelector('.quick-add-modal__close')?.focus();

    fetch('/products/' + handle + '?section_id=quick-add-form')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const formEl = doc.querySelector('[data-quick-add-form]') || doc.querySelector('.quick-add-form') || doc.body.firstElementChild;
        quickAddContent.innerHTML = formEl ? formEl.outerHTML : '<p>Unable to load product.</p>';
        if (formEl) initQuickAddForm(quickAddContent.querySelector('form'));
        const innerFocus = quickAddContent.querySelector(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
        );
        (innerFocus || quickAddModal.querySelector('.quick-add-modal__close'))?.focus();
      })
      .catch(() => {
        quickAddContent.innerHTML = '<p>Unable to load product.</p>';
      });
  };

  const closeQuickAdd = () => {
    if (!quickAddModal) return;
    quickAddModal.setAttribute('aria-hidden', 'true');
    quickAddModal.classList.remove('quick-add-modal--open');
    document.body.style.overflow = '';
    if (quickAddTrigger && typeof quickAddTrigger.focus === 'function') {
      quickAddTrigger.focus();
      quickAddTrigger = null;
    }
  };

  const initQuickAddForm = (form) => {
    if (!form) return;
    const formWrapper = form.closest('.quick-add-form');
    const variantPicker = form.querySelector('[data-variant-picker]');
    const variantIdInput = form.querySelector('[data-variant-id]');
    const variantJsonEl = form.querySelector('[data-variant-json]');
    const priceEl = formWrapper?.querySelector('[data-quick-add-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');

    if (addBtn) addBtn.dataset.addText = addBtn.textContent;

    const formatMoney = (cents) => {
      let currency = 'GBP';
      try {
        const currEl = form.querySelector('[data-currency]');
        if (currEl) {
          const parsed = JSON.parse(currEl.textContent);
          currency = typeof parsed === 'string' ? parsed : (parsed?.iso_code || parsed?.isoCode || 'GBP');
        }
      } catch (e) {}
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: String(currency) }).format(cents / 100);
    };

    if (variantPicker && variantIdInput && variantJsonEl) {
      let variants;
      try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) { variants = []; }

      const getOptionValues = () => {
        const values = {};
        variantPicker.querySelectorAll('[data-option-input]').forEach(input => {
          if (input.type === 'hidden' || input.checked) {
            const pos = input.getAttribute('data-option-position');
            if (pos) values[pos] = input.value;
          }
        });
        return values;
      };

      const findVariant = () => {
        const selected = getOptionValues();
        return variants.find(v => {
          const o1 = selected['1'] !== undefined ? selected['1'] : v.option1;
          const o2 = selected['2'] !== undefined ? selected['2'] : v.option2;
          const o3 = selected['3'] !== undefined ? selected['3'] : v.option3;
          return String(v.option1 || '') === String(o1 || '') && String(v.option2 || '') === String(o2 || '') && String(v.option3 || '') === String(o3 || '');
        });
      };

      const imageEl = formWrapper?.querySelector('[data-quick-add-image]');

      const updateVariant = (v) => {
        if (!v) return;
        variantIdInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.classList.toggle('button--disabled', !v.available);
          addBtn.textContent = addBtn.dataset.addText || 'Add to cart';
        }
        if (imageEl && v.featured_image && v.featured_image.src) {
          imageEl.src = v.featured_image.src;
          imageEl.alt = imageEl.alt || '';
        }
        variantPicker.querySelectorAll('.variant-picker__swatch--selected, .variant-picker__radio--selected').forEach(el => el.classList.remove('variant-picker__swatch--selected', 'variant-picker__radio--selected'));
        variantPicker.querySelectorAll('[data-option-input]').forEach(input => {
          if (input.type === 'hidden' || input.checked) {
            const label = input.closest('label');
            if (label) label.classList.add('variant-picker__swatch--selected', 'variant-picker__radio--selected');
          }
        });
      };

      const onVariantChange = (e) => {
        if (!e.target.matches('[data-option-input]')) return;
        updateVariant(findVariant());
      };
      variantPicker.addEventListener('change', onVariantChange);
      variantPicker.addEventListener('input', onVariantChange);
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const payload = buildCartPayload(form);
      const submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(async function(r) {
          const data = await r.json();
          if (!r.ok) throw new Error(data.description || data.message || 'add-failed');
          return data;
        })
        .then(function(lineItem) {
          return refreshCartDrawer().then(function() { return lineItem; });
        })
        .then(function(lineItem) {
          closeQuickAdd();
          showCartToast();
          const btn = form.querySelector('[data-add-to-cart]');
          const vid = parseInt(form.querySelector('[data-variant-id]')?.value || payload.id, 10);
          document.dispatchEvent(new CustomEvent('theme:addToCart', {
            detail: { lineItem, source: 'quick-add', productId: btn?.dataset.productId, productHandle: btn?.dataset.productHandle, variantId: vid }
          }));
        })
        .catch(function() {})
        .finally(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  };

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-quick-add-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      const handle = trigger.dataset.productHandle;
      if (handle) openQuickAdd(handle);
    }
    if (e.target.closest('[data-quick-add-close]')) closeQuickAdd();
  });

  // Collection switch + sort + filter drawer interactions
  document.querySelectorAll('[data-collection-switcher]').forEach(select => {
    select.addEventListener('change', function() {
      if (!this.value) return;
      window.location.href = this.value;
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach(select => {
    select.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-collection-filter-toggle]').forEach(btn => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    const root = btn.closest('[data-collection-filters]');
    const overlay = root && root.querySelector('[data-collection-filters-overlay]');
    const closeBtn = panel.querySelector('[data-collection-filter-close]');

    const closePanel = () => {
      panel.removeAttribute('data-open');
      btn.setAttribute('aria-expanded', 'false');
      if (overlay) {
        overlay.hidden = true;
        overlay.removeAttribute('data-open');
      }
      document.body.style.overflow = '';
    };

    const openPanel = () => {
      panel.setAttribute('data-open', '');
      btn.setAttribute('aria-expanded', 'true');
      if (overlay) {
        overlay.hidden = false;
        overlay.setAttribute('data-open', '');
      }
      document.body.style.overflow = 'hidden';
    };

    btn.addEventListener('click', () => {
      if (panel.hasAttribute('data-open')) closePanel();
      else openPanel();
    });

    if (overlay) overlay.addEventListener('click', closePanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.hasAttribute('data-open')) closePanel();
    });
  });

  // Cart page: AJAX quantity updates (syncs line prices, subtotal, header, drawer)
  function runCartQuantitySync(input) {
    var line = parseInt(input.getAttribute('data-line-index'), 10);
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) return;
    if (qty < 0) {
      input.value = 0;
      qty = 0;
    }
    input.setAttribute('data-cart-syncing', 'true');
    postCartLineChange(line, qty)
      .then(applyCartState)
      .catch(function(err) {
        alert(err.message || 'Could not update cart');
        return fetch((window.themeRoutes && window.themeRoutes.cartJsUrl) || '/cart.js', { credentials: 'same-origin' })
          .then(function(r) {
            return r.json();
          })
          .then(applyCartState);
      })
      .finally(function() {
        input.removeAttribute('data-cart-syncing');
      });
  }

  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = this.closest('.cart-item__quantity-controls');
      var input = wrap && wrap.querySelector('input[type="number"]');
      if (!input) return;
      var step = this.matches('[data-qty-plus]') ? 1 : -1;
      var min = parseInt(input.getAttribute('min'), 10);
      var minQty = isNaN(min) ? 1 : min;
      var val = parseInt(input.value, 10) || minQty;
      val = val + step;
      if (val < minQty) val = minQty;
      input.value = val;
      runCartQuantitySync(input);
    });
  });

  document.querySelectorAll('.cart-page input[data-line-index]').forEach(function(input) {
    input.addEventListener('change', function() {
      runCartQuantitySync(input);
    });
  });

  // TEMP: OneID checkout guard disabled
  /*
  // Cart page: block Checkout until OneID shows age verification success (verifyAge > 0 from snippet JSON)
  (function initOneIdCheckoutGuard() {
    var scriptEl = document.getElementById('oneid_widget_data_script');
    var container = document.getElementById('oneid_container');
    var checkoutEl = document.querySelector('.cart-page a[data-cart-checkout]');
    if (!scriptEl || !container || !checkoutEl) return;

    var verifyAge = 0;
    try {
      var cfg = JSON.parse(scriptEl.textContent.trim());
      verifyAge = parseInt(cfg.verifyAge, 10) || 0;
    } catch (err) {
      return;
    }
    if (verifyAge <= 0) return;

    var checkoutHref = checkoutEl.getAttribute('href') || '/checkout';

    function isAgeVerified() {
      return !!container.querySelector('.oid-alert.oid-success');
    }

    function syncCheckoutOneIdGate() {
      if (isAgeVerified()) {
        checkoutEl.setAttribute('href', checkoutHref);
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.removeAttribute('tabindex');
        checkoutEl.removeAttribute('title');
        checkoutEl.classList.remove('cart-page__checkout--blocked');
      } else {
        checkoutEl.setAttribute('href', '#');
        checkoutEl.setAttribute('aria-disabled', 'true');
        checkoutEl.setAttribute('tabindex', '-1');
        checkoutEl.setAttribute('title', 'Complete age verification above before checkout');
        checkoutEl.classList.add('cart-page__checkout--blocked');
      }
    }

    checkoutEl.addEventListener(
      'click',
      function(e) {
        if (!isAgeVerified()) {
          e.preventDefault();
          checkoutEl.setAttribute('href', '#');
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      true
    );

    syncCheckoutOneIdGate();

    var mo = new MutationObserver(function() {
      syncCheckoutOneIdGate();
    });
    mo.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
  })();
  */
})();
